import {load} from "@amcharts/amcharts5/.internal/core/util/Net";
import {Button, Col, Row, Space, Typography} from "antd";
import {convertDateStringToDateTimezone_7Dayjs} from "helper/common";
import React, {useState} from "react";
import {FORMAT_TIME} from "types/enums";
const ModalConfirm = props => {
  const [loading, setLoading] = useState(false);
  const {closeModal, submit, data, text = "đẩy XML"} = props;
  return (
    <div>
      <Row justify={"center"}>
        <Typography.Text strong>
          Ngày tháng quyết toán khác với thời gian thanh toán. Bạn có chắc chắn
          {` ${text}`}?
        </Typography.Text>
        <ul>
          {data?.map(el => (
            <>
              <li>
                <Row gutter={30}>
                  <Col>Mã bệnh nhân : {el.maBenhNhan}</Col>
                  Ngày xuất viện:{" "}
                  {convertDateStringToDateTimezone_7Dayjs(
                    el.ngayXuatVien,
                    FORMAT_TIME.dayFull
                  )}
                  <Col></Col>
                </Row>
              </li>
            </>
          ))}
        </ul>
      </Row>
      <Row justify={"end"}>
        <Space>
          <Button onClick={closeModal}>Hủy</Button>
          <Button
            type="primary"
            onClick={async () => {
              setLoading(true);
              await submit();
              setLoading(false);
              closeModal();
            }}
            loading={loading}
          >
            Xác nhận
          </Button>
        </Space>
      </Row>
    </div>
  );
};
export default ModalConfirm;
